export default "* Egern\n* Pattedyr\n* Akrobat\n* Forråd";